module.exports = __webpack_public_path__ + "static/media/mtaLogo.d1e2954e.svg";